import React, { ReactElement } from 'react'
import { styled } from '@mui/material'
import { PickersTextField, PickersTextFieldProps } from '@mui/x-date-pickers'
import { PICKERS_TEXT_FIELD_DEFAULT_STYLE } from 'src/ui-shared/base/form/control/TextField.style'

const StyledPickersTextFieldDefault = styled(PickersTextField)(() => ({
  ...PICKERS_TEXT_FIELD_DEFAULT_STYLE,
}))

export const PickersTextFieldDefault = (props: PickersTextFieldProps): ReactElement => {
  return (
    <StyledPickersTextFieldDefault
      {...props}
      variant={props.variant || 'filled'}
      fullWidth={props.fullWidth ?? true}
      slotProps={{
        ...props.slotProps,
        inputLabel: {
          ...props.slotProps?.inputLabel,
          shrink: props.slotProps?.inputLabel?.shrink ?? true,
        },
      }}
    />
  )
}
